import PropTypes from "prop-types";
import { useState } from "react";
import { useRef } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { supportedFileExtensions } from "../../utils";
import Spinner from "../Loader";
import warning_icon from "../../svg/warning-icon.svg";

const UploadSampleWorks = (props) => {
    const dispatch = useDispatch();
    const error = useSelector(state => state.ProfileReducer?.typeError)
    const { setServicesCount = () => {}, servicesCount = [], currentService, setCurrentService, show, close, handleAddUrlModal, samples, setSamples, UploadMedia, setSamplesUpload, urlError, setUrlError } = props;
    const uploadSampleRef = useRef();
    const isAppLoading = useSelector(state => state.Loader);
    const handleUploadSampleImg = () => {
        uploadSampleRef.current.click()
    }

    const handleSampleImageUpload = async (event) => {
        let file = event.target.files[0];
        const fileExtension = file.type?.split('/')[1]?.toString();
        if(supportedFileExtensions.indexOf(fileExtension?.toLowerCase() > -1) && file.size < 50000000) {
            setSamplesUpload(true)
            // setSamples({ image: file })
            const formData = new FormData()
            formData.append('file', file)
            dispatch({type: "SET_LOADER_STATUS", loading: true})
            const uploadResp = await UploadMedia(formData)
            if(uploadResp.status === 200) {
                const clonedServices = JSON.parse(JSON.stringify(servicesCount));
                const activeService = clonedServices.find(a => a.servicesuuid === currentService.servicesuuid);
                if(activeService) {
                    activeService.not_have_any_samples = false;
                    activeService.samples = (activeService.samples && Array.isArray(activeService.samples)) ? [...activeService.samples, { uploadSamples: uploadResp?.data?.url, url: "" }] : [{ uploadSamples: uploadResp?.data?.url, url: "" }];
                }
                setServicesCount(clonedServices)
            }
            dispatch({ type: 'SHOW_ERROR', payload: { message: '', type: '' } })
            dispatch({type: "SET_LOADER_STATUS", loading: false})
            close()
        } else {
            dispatch({ type: "SHOW_ERROR", payload: { message: 'Formate not supported or image Size is greater then 50 mb.', type: 'FILE_INVALID' } })
        }
    }
    
    const render = () => {
        return (
            <>
                <a onClick={() => handleUploadSampleImg()}>
                    <b class="icon-upload"></b>
                    Upload File
                </a>
                <input hidden type='file' ref={uploadSampleRef} onChange={handleSampleImageUpload} />
                <a onClick={() => handleAddUrlModal()}>
                    <b class="icon-link"></b>
                    Add URL
                </a>
            </>)
    }
    const renderError = () => {
        if (urlError) {
            return (
                <div class="sampleEnsure">
                    <h5 className="d-flex"><img src={warning_icon} alt="warning" className="w-15" />Your upload has failed. Please ensure that:</h5>
                    <ul>
                        <li>You Have entered a valid URL.</li>
                    </ul>
                </div>
            )
        } else if (error?.type === "FILE_INVALID") {
            return(
                <div class="sampleEnsure">
                    <h5 className="d-flex"><img src={warning_icon} alt="warning" className="w-15" />Your upload has failed. Please ensure that:</h5>
                    <ul>
                        <li>The file is in the format: PDF/PNG/JPG/Tiff</li>
                        <li>File size should be less than 50 MB </li>
                    </ul>
                </div>
            )
        }
        return null
    }

    return (
        <Modal centered show={show} size={'sm'}>
            <div class="modal-dialog-centered">
                <div class="">
                    <div class="modal-header">
                        <h5 class="modal-title">Upload Sample Work</h5>
                        <p>Please choose from the options below</p>
                        <button type="button" class="btn-close" onClick={close}></button>
                    </div>
                    {
                        isAppLoading ? <Spinner show={isAppLoading} /> : (
                            <div class="modal-body">
                                <div class="profileModal">
                                    <div class="profileModal-opt">
                                        {render()}
                                    </div>
                                    {renderError()}
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </Modal>
    );
};
UploadSampleWorks.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    handleAddUrlModal: PropTypes.func,
    samples: PropTypes.object,
    currentService: PropTypes.object,
    setCurrentService: PropTypes.func,
    handleUploadSampleImg: PropTypes.func,
    setSamples: PropTypes.func,
    UploadMedia: PropTypes.func,
    setSamplesUpload: PropTypes.func
};

UploadSampleWorks.defaultProps = {
    show: false,
    close: () => null,
    handleAddUrlModal: () => null,
    samples: {},
    currentService: {},
    setCurrentService: () => {},
    handleUploadSampleImg: () => null,
    handleSampleImageUpload: () => null,
    setSamples: () => null,
    UploadMedia: () => null,
    setSamplesUpload: () => null
};

export default UploadSampleWorks;
